{
  "id": "greeks",
  "name": {
    "pt-BR": "Gregos",
    "en": "Greeks"
  },
  "icon": "ui/pantheon-greeks",
  "workers": ["villager", "fishing-ship"],
  "townCenter": "town-center",
  "start": {
    "resources": {
      "food": 200,
      "wood": 250,
      "gold": 50,
      "favor": 0
    },
    "units": {
      "villager": 4,
      "kataskopos": 1
    },
    "buildings": {
      "town-center": 1,
      "sentry-tower": 4
    },
    "popCap": 15
  },
  "favor": {
    "type": "templeWorkers",
    "building": "temple",
    "table": [
      6.0, 11.11, 15.53, 19.41, 22.85, 25.94, 28.75, 31.3, 33.66, 35.83, 37.86, 39.76, 41.55, 43.24,
      44.84, 46.37, 47.82, 49.22, 50.56, 51.85, 53.1, 54.31, 55.48, 56.61, 57.72, 58.8, 59.85,
      60.88, 61.89, 62.88
    ],
    "meta": {
      "source": "Game files 19.17020 (game.cfg, proto.xml, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "game.cfg: PrayerEfficiencyEarlyIncomeReductionV=10.1111, PrayerEfficiencyLaterGrowthG=0.01, PrayerEfficiencyModifierZ=10.0; proto.xml VillagerGreek Gather AbstractTemple rate 0.1. favor/s = N x (rate x Z / 10) x (1/(N + V) + G) = N x M x (1/(N + 10.1111) + 0.01), N = villagers praying across all Temples, M = 1 (Zeus and Golden Apples each +0.2 BasePercent on the rate, via favorRate modifiers). Table = favor/min for N = 1..30 at M = 1; matches the owner measurements (6.00 and 31.30). No praying limit in the files (Temple maxcontained 5 is for garrison); extrapolate with the formula above 30. No favor cap in the files."
    }
  },
  "gods": ["zeus", "hades", "poseidon"],
  "ageUps": [
    {
      "pantheon": "greeks",
      "to": "classical",
      "cost": {
        "food": 400
      },
      "time": 60,
      "at": "town-center",
      "requiresAnyOf": [["temple"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ClassicalAgeAthena/Hermes/Ares: 400 food, 60 s, needs a Temple (typecount AbstractTemple >= 1). At Town Center or Village Center. Each gives one free myth unit at a Temple."
      }
    },
    {
      "pantheon": "greeks",
      "to": "heroic",
      "cost": {
        "food": 800,
        "gold": 500
      },
      "time": 75,
      "at": "town-center",
      "requiresAnyOf": [["armory"], ["market"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "HeroicAgeApollo/Dionysus/Aphrodite: 800 food + 500 gold, 75 s, needs an Armory or a Market (OrPrereqs). At Town Center or Village Center. HeroicAgeGreek also creates a free Scylla at a Dock (if any)."
      }
    },
    {
      "pantheon": "greeks",
      "to": "mythic",
      "cost": {
        "food": 1200,
        "gold": 1200
      },
      "time": 120,
      "at": "town-center",
      "requiresAnyOf": [["fortress"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "MythicAgeHera/Artemis/Hephaestus: 1200 food + 1200 gold, 120 s, needs a Fortress. At Town Center or Village Center. MythicAgeGreek also creates a free Carcinos at a Dock (if any)."
      }
    }
  ],
  "units": [
    {
      "id": "villager",
      "name": {
        "pt-BR": "Aldeão",
        "en": "Villager"
      },
      "icon": "units/greeks-villager",
      "pantheon": "greeks",
      "tags": ["worker", "human"],
      "cost": {
        "food": 50
      },
      "pop": 1,
      "trainTime": 17,
      "trainedAt": ["town-center", "village-center"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "hunt": 60,
          "herd": 54,
          "berries": 42,
          "farm": 42,
          "wood": 60,
          "gold": 51
        },
        "buildRate": 1,
        "canBuild": true,
        "needsDropsite": true
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather rates (proto.xml Gather/Hunting rates per second x 60): hunt 1.0, herd 0.9, berries (WildCrops) 0.7, farm 0.7, wood 1.0, gold 0.85. Base carry 15 food / 10 wood / 10 gold. Build rate 1.0. Limit 100. Village Centers have trainingrate 0.75 (villagers take 1/0.75 = 1.33x as long there; no per-building modifier in the schema). Also prays at Temples (Gather AbstractTemple 0.1/s, see favor rule)."
      }
    },
    {
      "id": "fishing-ship",
      "name": {
        "pt-BR": "Navio Pesqueiro",
        "en": "Fishing Ship"
      },
      "plural": {
        "pt-BR": "Navios Pesqueiros",
        "en": "Fishing Ships"
      },
      "icon": "units/greeks-fishing-ship",
      "pantheon": "greeks",
      "tags": ["ship", "worker"],
      "cost": {
        "wood": 50
      },
      "pop": 1,
      "trainTime": 18,
      "trainedAt": ["dock"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "fish": 33
        },
        "canBuild": false,
        "needsDropsite": true
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather FishResource 0.55/s = 33/min. Limit 50."
      }
    },
    {
      "id": "kataskopos",
      "name": {
        "pt-BR": "Kataskopos",
        "en": "Kataskopos"
      },
      "icon": "units/greeks-kataskopos",
      "pantheon": "greeks",
      "tags": ["scout", "cavalry", "human"],
      "cost": {
        "food": 75
      },
      "pop": 1,
      "trainTime": 0,
      "trainedAt": [],
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Starting scout; cannot be trained. cost is the proto cost (75 food), never paid."
      }
    },
    {
      "id": "hoplite",
      "name": {
        "pt-BR": "Hoplita",
        "en": "Hoplite"
      },
      "icon": "units/greeks-hoplite",
      "pantheon": "greeks",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 50,
        "gold": 40
      },
      "pop": 2,
      "trainTime": 12,
      "trainedAt": ["military-academy"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Zeus: Hoplites +15% speed (not modelled)."
      }
    },
    {
      "id": "hypaspist",
      "name": {
        "pt-BR": "Hipaspista",
        "en": "Hypaspist"
      },
      "icon": "units/greeks-hypaspist",
      "pantheon": "greeks",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 60,
        "gold": 25
      },
      "pop": 2,
      "trainTime": 9.5,
      "trainedAt": ["military-academy"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by HeroicAgeGreek; Ares' Deimos' Sword of Dread also enables it in the Classical Age (not expressible: requires is AND-only, so the unit stays at age heroic)."
      }
    },
    {
      "id": "myrmidon",
      "name": {
        "pt-BR": "Mirmidão",
        "en": "Myrmidon"
      },
      "icon": "units/greeks-myrmidon",
      "pantheon": "greeks",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 70,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 6.5,
      "trainedAt": ["fortress"],
      "age": "mythic",
      "requires": ["zeus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Zeus unique unit (MythicAgeZeus). Hera's Argive Patronage gives Fortresses a Maintain action that trains one free Myrmidon per 60 train points."
      }
    },
    {
      "id": "toxotes",
      "name": {
        "pt-BR": "Toxotes",
        "en": "Toxotes"
      },
      "icon": "units/greeks-toxotes",
      "pantheon": "greeks",
      "tags": ["archer", "human"],
      "cost": {
        "wood": 55,
        "gold": 35
      },
      "pop": 2,
      "trainTime": 15,
      "trainedAt": ["archery-range"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "peltast",
      "name": {
        "pt-BR": "Peltasta",
        "en": "Peltast"
      },
      "icon": "units/greeks-peltast",
      "pantheon": "greeks",
      "tags": ["archer", "human"],
      "cost": {
        "wood": 70,
        "gold": 25
      },
      "pop": 2,
      "trainTime": 10.5,
      "trainedAt": ["archery-range"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "gastraphetoros",
      "name": {
        "pt-BR": "Gastrafeta",
        "en": "Gastraphetoros"
      },
      "icon": "units/greeks-gastraphetoros",
      "pantheon": "greeks",
      "tags": ["archer", "human"],
      "cost": {
        "wood": 100,
        "gold": 60
      },
      "pop": 3,
      "trainTime": 9,
      "trainedAt": ["fortress"],
      "age": "mythic",
      "requires": ["hades"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hades unique unit (MythicAgeHades)."
      }
    },
    {
      "id": "hippeus",
      "name": {
        "pt-BR": "Hippeis",
        "en": "Hippeus"
      },
      "icon": "units/greeks-hippeus",
      "pantheon": "greeks",
      "tags": ["cavalry", "human"],
      "cost": {
        "food": 40,
        "gold": 80
      },
      "pop": 3,
      "trainTime": 16,
      "trainedAt": ["stable"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "prodromos",
      "name": {
        "pt-BR": "Prodromos",
        "en": "Prodromos"
      },
      "icon": "units/greeks-prodromos",
      "pantheon": "greeks",
      "tags": ["cavalry", "human"],
      "cost": {
        "food": 70,
        "gold": 40
      },
      "pop": 3,
      "trainTime": 12,
      "trainedAt": ["stable"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "hetairos",
      "name": {
        "pt-BR": "Hetairos",
        "en": "Hetairos"
      },
      "icon": "units/greeks-hetairos",
      "pantheon": "greeks",
      "tags": ["cavalry", "human"],
      "cost": {
        "food": 50,
        "gold": 90
      },
      "pop": 3,
      "trainTime": 8,
      "trainedAt": ["fortress"],
      "age": "mythic",
      "requires": ["poseidon"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Poseidon unique unit (MythicAgePoseidon)."
      }
    },
    {
      "id": "militia",
      "name": {
        "pt-BR": "Milícia",
        "en": "Militia"
      },
      "icon": "units/greeks-militia",
      "pantheon": "greeks",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 70
      },
      "pop": 1,
      "trainTime": 0,
      "trainedAt": [],
      "age": "archaic",
      "requires": ["poseidon"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trainable: Poseidon partisans spawn from razed buildings (partisancount 1-8 per building, 30 for a Wonder). cost is the proto cost (70 food), never paid."
      }
    },
    {
      "id": "petrobolos",
      "name": {
        "pt-BR": "Petrobolos",
        "en": "Petrobolos"
      },
      "icon": "units/greeks-petrobolos",
      "pantheon": "greeks",
      "tags": ["siege"],
      "cost": {
        "wood": 125,
        "gold": 150
      },
      "pop": 3,
      "trainTime": 15,
      "trainedAt": ["fortress"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "helepolis",
      "name": {
        "pt-BR": "Helepolis",
        "en": "Helepolis"
      },
      "icon": "units/greeks-helepolis",
      "pantheon": "greeks",
      "tags": ["siege"],
      "cost": {
        "wood": 300,
        "gold": 200
      },
      "pop": 5,
      "trainTime": 24,
      "trainedAt": ["fortress"],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "transport-ship",
      "name": {
        "pt-BR": "Navio de Transporte",
        "en": "Transport Ship"
      },
      "icon": "units/greeks-transport-ship",
      "pantheon": "greeks",
      "tags": ["ship"],
      "cost": {
        "wood": 110
      },
      "pop": 1,
      "trainTime": 19,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "trireme",
      "name": {
        "pt-BR": "Trirreme",
        "en": "Trireme"
      },
      "icon": "units/greeks-trireme",
      "pantheon": "greeks",
      "tags": ["ship", "human"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "pentekonter",
      "name": {
        "pt-BR": "Penteconter",
        "en": "Pentekonter"
      },
      "icon": "units/greeks-pentekonter",
      "pantheon": "greeks",
      "tags": ["ship", "human"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "juggernaut",
      "name": {
        "pt-BR": "Juggernaut",
        "en": "Juggernaut"
      },
      "icon": "units/greeks-juggernaut",
      "pantheon": "greeks",
      "tags": ["ship", "siege"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "caravan",
      "name": {
        "pt-BR": "Caravana de Burro",
        "en": "Donkey Caravan"
      },
      "icon": "units/greeks-caravan",
      "pantheon": "greeks",
      "tags": ["caravan"],
      "cost": {
        "food": 100,
        "wood": 25
      },
      "pop": 1,
      "trainTime": 18,
      "trainedAt": ["market"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Official name Donkey Caravan (id kept as caravan). Limit 60. Poseidon: +0.1 speed per age (+0.3 in Heroic, +0.4 in Mythic)."
      }
    },
    {
      "id": "jason",
      "name": {
        "pt-BR": "Jasão (Herói)",
        "en": "Jason (Hero)"
      },
      "icon": "units/greeks-jason",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "food": 100,
        "wood": 50
      },
      "pop": 2,
      "trainTime": 5,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "archaic",
      "requires": ["zeus", "temple"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by JasonEnable (needs at least one Temple alive)."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 5 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 5 s x 0.9^(age index). Value here = the age the hero unlocks; per age: archaic 5, classical 4.5, heroic 4.05, mythic 3.645. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "ajax",
      "name": {
        "pt-BR": "Ájax (Herói)",
        "en": "Ajax (Hero)"
      },
      "icon": "units/greeks-ajax",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "food": 100,
        "wood": 50
      },
      "pop": 2,
      "trainTime": 5,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "archaic",
      "requires": ["hades", "temple"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by AjaxEnable (needs at least one Temple alive)."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 5 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 5 s x 0.9^(age index). Value here = the age the hero unlocks; per age: archaic 5, classical 4.5, heroic 4.05, mythic 3.645. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "theseus",
      "name": {
        "pt-BR": "Teseu (Herói)",
        "en": "Theseus (Hero)"
      },
      "icon": "units/greeks-theseus",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "food": 100,
        "wood": 50
      },
      "pop": 2,
      "trainTime": 5,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "archaic",
      "requires": ["poseidon", "temple"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by TheseusEnable (needs at least one Temple alive)."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 5 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 5 s x 0.9^(age index). Value here = the age the hero unlocks; per age: archaic 5, classical 4.5, heroic 4.05, mythic 3.645. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "heracles",
      "name": {
        "pt-BR": "Hércules (Herói)",
        "en": "Heracles (Hero)"
      },
      "icon": "units/greeks-heracles",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "food": 75,
        "gold": 175,
        "favor": 2
      },
      "pop": 3,
      "trainTime": 18,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "classical",
      "requires": ["zeus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by ClassicalAgeZeus."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 20 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 20 s x 0.9^(age index). Value here = the age the hero unlocks; per age: classical 18, heroic 16.2, mythic 14.58. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "achilles",
      "name": {
        "pt-BR": "Aquiles (Herói)",
        "en": "Achilles (Hero)"
      },
      "icon": "units/greeks-achilles",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "food": 75,
        "gold": 175,
        "favor": 2
      },
      "pop": 3,
      "trainTime": 18,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "classical",
      "requires": ["hades"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by ClassicalAgeHades."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 20 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 20 s x 0.9^(age index). Value here = the age the hero unlocks; per age: classical 18, heroic 16.2, mythic 14.58. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "atalanta",
      "name": {
        "pt-BR": "Atalanta (Heroína)",
        "en": "Atalanta (Hero)"
      },
      "icon": "units/greeks-atalanta",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "food": 75,
        "gold": 175,
        "favor": 2
      },
      "pop": 3,
      "trainTime": 18,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "classical",
      "requires": ["poseidon"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by ClassicalAgePoseidon."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 20 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 20 s x 0.9^(age index). Value here = the age the hero unlocks; per age: classical 18, heroic 16.2, mythic 14.58. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "odysseus",
      "name": {
        "pt-BR": "Odisseu (Herói)",
        "en": "Odysseus (Hero)"
      },
      "icon": "units/greeks-odysseus",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "wood": 250,
        "gold": 100,
        "favor": 4
      },
      "pop": 2,
      "trainTime": 20.25,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "heroic",
      "requires": ["zeus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by HeroicAgeZeus."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 25 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 25 s x 0.9^(age index). Value here = the age the hero unlocks; per age: heroic 20.25, mythic 18.225. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "chiron",
      "name": {
        "pt-BR": "Quíron (Herói)",
        "en": "Chiron (Hero)"
      },
      "icon": "units/greeks-chiron",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "wood": 250,
        "gold": 100,
        "favor": 4
      },
      "pop": 2,
      "trainTime": 20.25,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "heroic",
      "requires": ["hades"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by HeroicAgeHades."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 25 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 25 s x 0.9^(age index). Value here = the age the hero unlocks; per age: heroic 20.25, mythic 18.225. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "hippolyta",
      "name": {
        "pt-BR": "Hipólita (Heroína)",
        "en": "Hippolyta (Hero)"
      },
      "icon": "units/greeks-hippolyta",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "wood": 250,
        "gold": 100,
        "favor": 4
      },
      "pop": 2,
      "trainTime": 20.25,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "heroic",
      "requires": ["poseidon"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by HeroicAgePoseidon."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 25 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 25 s x 0.9^(age index). Value here = the age the hero unlocks; per age: heroic 20.25, mythic 18.225. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "bellerophon",
      "name": {
        "pt-BR": "Belerofonte (Herói)",
        "en": "Bellerophon (Hero)"
      },
      "icon": "units/greeks-bellerophon",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "gold": 400,
        "favor": 6
      },
      "pop": 4,
      "trainTime": 21.87,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "mythic",
      "requires": ["zeus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by MythicAgeZeus."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 30 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 30 s x 0.9^(age index). Value here = the age the hero unlocks; per age: mythic 21.87. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "perseus",
      "name": {
        "pt-BR": "Perseus (Herói)",
        "en": "Perseus (Hero)"
      },
      "icon": "units/greeks-perseus",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "gold": 400,
        "favor": 6
      },
      "pop": 4,
      "trainTime": 21.87,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "mythic",
      "requires": ["hades"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by MythicAgeHades."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 30 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 30 s x 0.9^(age index). Value here = the age the hero unlocks; per age: mythic 21.87. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "polyphemus",
      "name": {
        "pt-BR": "Polifemo (Herói)",
        "en": "Polyphemus (Hero)"
      },
      "icon": "units/greeks-polyphemus",
      "pantheon": "greeks",
      "tags": ["hero"],
      "cost": {
        "gold": 400,
        "favor": 6
      },
      "pop": 4,
      "trainTime": 21.87,
      "trainedAt": ["town-center", "village-center", "fortress"],
      "age": "mythic",
      "requires": ["poseidon"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero, enabled by MythicAgePoseidon."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 30 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 30 s x 0.9^(age index). Value here = the age the hero unlocks; per age: mythic 21.87. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "the-argo",
      "name": {
        "pt-BR": "O Argo (Herói)",
        "en": "The Argo (Hero)"
      },
      "icon": "units/greeks-the-argo",
      "pantheon": "greeks",
      "tags": ["hero", "ship"],
      "cost": {
        "wood": 200,
        "favor": 4
      },
      "pop": 4,
      "trainTime": 20.25,
      "trainedAt": ["dock"],
      "age": "heroic",
      "requires": ["aphrodite", "argonauts"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Argonauts (Aphrodite) spawns one at a Dock and enables it; can be rebuilt at the Dock (buildlimit 1). Hero ship."
      },
      "fieldMeta": {
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml, techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Proto trainpoints 25 s. ClassicalAgeGreek, HeroicAgeGreek and MythicAgeGreek each apply TrainPoints x0.90 (Percent) to HeroShadowUpgraded, so the time is 25 s x 0.9^(age index). Value here = the age the hero unlocks; per age: heroic 20.25, mythic 18.225. The schema has no per-age modifier."
        },
        "splitQueue": {
          "source": "Game files 19.17020 (proto.xml flag SplitQueue)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "STR_LOADINGSCREEN_TIP_58: Greek Heroes can be trained while other units or technologies (including Age Ups) are in the queue."
        }
      },
      "splitQueue": true
    },
    {
      "id": "pegasus",
      "name": {
        "pt-BR": "Pégaso",
        "en": "Pegasus"
      },
      "icon": "units/greeks-pegasus",
      "pantheon": "greeks",
      "tags": ["myth", "scout"],
      "cost": {
        "food": 50,
        "favor": 2
      },
      "pop": 2,
      "trainTime": 6,
      "trainedAt": ["temple"],
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled for all Greeks in the Archaic Age (ArchaicAgeGreek). Hermes' Winged Messenger adds a separate respawning Pegasus (PegasusWingedMessenger, not modelled)."
      }
    },
    {
      "id": "minotaur",
      "name": {
        "pt-BR": "Minotauro",
        "en": "Minotaur"
      },
      "icon": "units/greeks-minotaur",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 180,
        "favor": 14
      },
      "pop": 3,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["athena"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "centaur",
      "name": {
        "pt-BR": "Centauro",
        "en": "Centaur"
      },
      "icon": "units/greeks-centaur",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 180,
        "favor": 14
      },
      "pop": 3,
      "trainTime": 22,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["hermes"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "cyclops",
      "name": {
        "pt-BR": "Ciclope",
        "en": "Cyclops"
      },
      "icon": "units/greeks-cyclops",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 150,
        "favor": 18
      },
      "pop": 3,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["ares"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "manticore",
      "name": {
        "pt-BR": "Mantícora",
        "en": "Manticore"
      },
      "icon": "units/greeks-manticore",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 250,
        "favor": 22
      },
      "pop": 4,
      "trainTime": 17,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["apollo"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "hydra",
      "name": {
        "pt-BR": "Hidra",
        "en": "Hydra"
      },
      "icon": "units/greeks-hydra",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 250,
        "favor": 26
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["dionysus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "nemean-lion",
      "name": {
        "pt-BR": "Leão de Nemeia",
        "en": "Nemean Lion"
      },
      "icon": "units/greeks-nemean-lion",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 250,
        "favor": 22
      },
      "pop": 3,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["aphrodite"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "scylla",
      "name": {
        "pt-BR": "Cila",
        "en": "Scylla"
      },
      "icon": "units/greeks-scylla",
      "pantheon": "greeks",
      "tags": ["myth", "ship"],
      "cost": {
        "gold": 200,
        "favor": 20
      },
      "pop": 4,
      "trainTime": 15,
      "trainedAt": ["dock"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled for all Greeks by HeroicAgeGreek, which also creates one free Scylla at a Dock when you reach the Heroic Age (only if you own a Dock; not modelled)."
      }
    },
    {
      "id": "colossus",
      "name": {
        "pt-BR": "Colosso",
        "en": "Colossus"
      },
      "icon": "units/greeks-colossus",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 350,
        "favor": 30
      },
      "pop": 4,
      "trainTime": 24,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["hephaestus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "medusa",
      "name": {
        "pt-BR": "Medusa",
        "en": "Medusa"
      },
      "icon": "units/greeks-medusa",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 250,
        "favor": 24
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["hera"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "chimera",
      "name": {
        "pt-BR": "Quimera",
        "en": "Chimera"
      },
      "icon": "units/greeks-chimera",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 280,
        "favor": 26
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["artemis"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Free one at a Temple when you age up with its minor god (CreateUnit in the age tech). Zeus: -1 pop via the Zeus modifier."
      }
    },
    {
      "id": "carcinos",
      "name": {
        "pt-BR": "Carcinos",
        "en": "Carcinos"
      },
      "icon": "units/greeks-carcinos",
      "pantheon": "greeks",
      "tags": ["myth", "ship"],
      "cost": {
        "wood": 200,
        "favor": 15
      },
      "pop": 3,
      "trainTime": 9,
      "trainedAt": ["dock"],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled for all Greeks by MythicAgeGreek, which also creates one free Carcinos at a Dock when you reach the Mythic Age (only if you own a Dock; not modelled)."
      }
    },
    {
      "id": "hippocampus",
      "name": {
        "pt-BR": "Hipocampo",
        "en": "Hippocampus"
      },
      "icon": "units/greeks-hippocampus",
      "pantheon": "greeks",
      "tags": ["myth", "ship", "scout"],
      "cost": {},
      "pop": 0,
      "trainTime": 0,
      "trainedAt": [],
      "age": "archaic",
      "requires": ["poseidon", "dock"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Poseidon (ArchaicAgePoseidon): HippocampusRespawn creates one at a Dock whenever you own a Dock and have none alive. Not trainable, pop 0."
      }
    },
    {
      "id": "shade-of-hades",
      "name": {
        "pt-BR": "Sombra de Hades",
        "en": "Shade of Hades"
      },
      "icon": "units/greeks-shade-of-hades",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 100,
        "favor": 5
      },
      "pop": 1,
      "trainTime": 0,
      "trainedAt": [],
      "age": "archaic",
      "requires": ["hades"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trainable: major_gods.xml <shades> gives each fallen HumanSoldier a 20% chance to return as a Shade after 10 s. cost is the proto cost (100 gold, 5 favor), never paid."
      }
    }
  ],
  "buildings": [
    {
      "id": "town-center",
      "name": {
        "pt-BR": "Centro Urbano",
        "en": "Town Center"
      },
      "icon": "buildings/greeks-town-center",
      "pantheon": "greeks",
      "cost": {
        "wood": 350,
        "gold": 350
      },
      "buildTime": 150,
      "popCap": 15,
      "age": "classical",
      "trains": [
        "villager",
        "jason",
        "ajax",
        "theseus",
        "heracles",
        "achilles",
        "atalanta",
        "odysseus",
        "chiron",
        "hippolyta",
        "bellerophon",
        "perseus",
        "polyphemus"
      ],
      "researches": [
        "masons",
        "architects",
        "fortified-town-center",
        "divine-blood",
        "golden-apples"
      ],
      "dropsiteFor": ["hunt", "herd", "berries", "farm", "wood", "gold"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Players start with one. buildlimit 1 (shared with Village Centers) until ClassicalAgeGeneral sets it to unlimited, so new ones from the Classical Age, on Settlements. +10 pop with Fortified Town Center. Age-ups are researched here (and at Village Centers)."
      }
    },
    {
      "id": "village-center",
      "name": {
        "pt-BR": "Centro de Aldeia",
        "en": "Village Center"
      },
      "icon": "buildings/greeks-village-center",
      "pantheon": "greeks",
      "cost": {
        "wood": 350,
        "gold": 350
      },
      "buildTime": 150,
      "age": "classical",
      "trains": [
        "villager",
        "jason",
        "ajax",
        "theseus",
        "heracles",
        "achilles",
        "atalanta",
        "odysseus",
        "chiron",
        "hippolyta",
        "bellerophon",
        "perseus",
        "polyphemus"
      ],
      "dropsiteFor": ["hunt", "herd", "berries", "farm", "wood", "gold"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "No pop support. trainingrate 0.75 (villagers take 1.33x as long). Shares the Town Center buildlimit (1 in the Archaic Age, so only buildable there if you have no center; unlimited from the Classical Age). Can also advance ages and research Masons, Architects, Divine Blood and Golden Apples."
      },
      "researches": ["masons", "architects", "divine-blood", "golden-apples"]
    },
    {
      "id": "house",
      "name": {
        "pt-BR": "Casa",
        "en": "House"
      },
      "icon": "buildings/greeks-house",
      "pantheon": "greeks",
      "cost": {
        "wood": 50
      },
      "buildTime": 15,
      "popCap": 10,
      "limit": 16,
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Limit 16, +10 pop."
      }
    },
    {
      "id": "temple",
      "name": {
        "pt-BR": "Templo",
        "en": "Temple"
      },
      "icon": "buildings/greeks-temple",
      "pantheon": "greeks",
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "buildTime": 40,
      "age": "archaic",
      "trains": [
        "pegasus",
        "minotaur",
        "centaur",
        "cyclops",
        "manticore",
        "hydra",
        "nemean-lion",
        "colossus",
        "medusa",
        "chimera"
      ],
      "researches": [
        "olympian-parentage",
        "omniscience",
        "labyrinth-of-minos",
        "sylvan-lore",
        "winged-messenger",
        "will-of-kronos",
        "oracle",
        "temple-of-healing",
        "chthonic-rites",
        "dionysia",
        "roar-of-orthus",
        "hand-of-talos",
        "shoulder-of-talos",
        "face-of-the-gorgon",
        "monstrous-rage",
        "flames-of-typhon",
        "golden-apples"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Villagers pray here for favor (see favor rule). Required for the Classical Age and for the Archaic heroes."
      }
    },
    {
      "id": "granary",
      "name": {
        "pt-BR": "Celeiro",
        "en": "Granary"
      },
      "icon": "buildings/greeks-granary",
      "pantheon": "greeks",
      "cost": {
        "wood": 50
      },
      "buildTime": 15,
      "age": "archaic",
      "researches": ["husbandry", "plow", "irrigation", "flood-control", "survival-equipment"],
      "dropsiteFor": ["hunt", "herd", "berries", "farm"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "storehouse",
      "name": {
        "pt-BR": "Armazém",
        "en": "Storehouse"
      },
      "icon": "buildings/greeks-storehouse",
      "pantheon": "greeks",
      "cost": {
        "wood": 50
      },
      "buildTime": 15,
      "age": "archaic",
      "researches": [
        "hand-axe",
        "bow-saw",
        "carpenters",
        "pickaxe",
        "shaft-mine",
        "quarry",
        "vaults-of-erebus"
      ],
      "dropsiteFor": ["wood", "gold"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "farm",
      "name": {
        "pt-BR": "Fazenda",
        "en": "Farm"
      },
      "icon": "buildings/greeks-farm",
      "pantheon": "greeks",
      "tags": ["farm"],
      "cost": {
        "wood": 75
      },
      "buildTime": 10,
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled for Greeks by ClassicalAgeGreek. One gatherer per farm (gathererlimit 1), 9999 food."
      }
    },
    {
      "id": "market",
      "name": {
        "pt-BR": "Mercado",
        "en": "Market"
      },
      "icon": "buildings/greeks-market",
      "pantheon": "greeks",
      "cost": {
        "wood": 150
      },
      "buildTime": 40,
      "age": "classical",
      "trains": ["caravan"],
      "researches": ["tax-collectors", "ambassadors", "coinage"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by ClassicalAgeGreek. Poseidon: wood cost x0.70, buy factor -0.10 / sell factor +0.10. Market (or Armory) unlocks the Heroic Age."
      }
    },
    {
      "id": "dock",
      "name": {
        "pt-BR": "Doca",
        "en": "Dock"
      },
      "icon": "buildings/greeks-dock",
      "pantheon": "greeks",
      "cost": {
        "wood": 100
      },
      "buildTime": 30,
      "age": "archaic",
      "trains": [
        "fishing-ship",
        "transport-ship",
        "trireme",
        "pentekonter",
        "juggernaut",
        "the-argo",
        "scylla",
        "carcinos"
      ],
      "researches": [
        "purse-seine",
        "salt-amphora",
        "enclosed-deck",
        "heroic-fleet",
        "heavy-warships",
        "champion-warships",
        "conscript-sailors",
        "argonauts",
        "anastrophe",
        "chthonic-rites"
      ],
      "dropsiteFor": ["fish", "hunt", "herd", "berries", "farm"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Food drop site (FoodDropsite), so land workers can also drop food here."
      }
    },
    {
      "id": "military-academy",
      "name": {
        "pt-BR": "Academia Militar",
        "en": "Military Academy"
      },
      "icon": "buildings/greeks-military-academy",
      "pantheon": "greeks",
      "cost": {
        "wood": 100
      },
      "buildTime": 25,
      "age": "classical",
      "trains": ["hoplite", "hypaspist"],
      "researches": [
        "medium-infantry",
        "heavy-infantry",
        "champion-infantry",
        "levy-infantry",
        "conscript-infantry",
        "aegis-shield",
        "sarissa",
        "phobos-spear-of-panic",
        "deimos-sword-of-dread"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "archery-range",
      "name": {
        "pt-BR": "Campo de Arqueiros",
        "en": "Archery Range"
      },
      "icon": "buildings/greeks-archery-range",
      "pantheon": "greeks",
      "cost": {
        "wood": 100
      },
      "buildTime": 25,
      "age": "classical",
      "trains": ["toxotes", "peltast"],
      "researches": [
        "medium-ranged-soldiers",
        "heavy-ranged-soldiers",
        "champion-ranged-soldiers",
        "levy-ranged-soldiers",
        "conscript-ranged-soldiers",
        "enyos-bow-of-horror",
        "sun-ray",
        "shafts-of-plague"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "stable",
      "name": {
        "pt-BR": "Estábulo",
        "en": "Stable"
      },
      "icon": "buildings/greeks-stable",
      "pantheon": "greeks",
      "cost": {
        "wood": 100
      },
      "buildTime": 25,
      "age": "classical",
      "trains": ["hippeus", "prodromos"],
      "researches": [
        "medium-cavalry",
        "heavy-cavalry",
        "champion-cavalry",
        "levy-cavalry",
        "conscript-cavalry",
        "lord-of-horses",
        "spirited-charge",
        "thracian-horses",
        "phobos-spear-of-panic"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Poseidon: wood cost x0.70."
      }
    },
    {
      "id": "armory",
      "name": {
        "pt-BR": "Armaria",
        "en": "Armory"
      },
      "icon": "buildings/greeks-armory",
      "pantheon": "greeks",
      "cost": {
        "wood": 150
      },
      "buildTime": 40,
      "age": "classical",
      "researches": [
        "copper-weapons",
        "copper-armor",
        "copper-shields",
        "bronze-weapons",
        "bronze-armor",
        "bronze-shields",
        "iron-weapons",
        "iron-armor",
        "iron-shields",
        "ballistics",
        "burning-pitch",
        "forge-of-olympus",
        "olympian-weapons",
        "aegis-shield",
        "sarissa",
        "phobos-spear-of-panic",
        "deimos-sword-of-dread",
        "enyos-bow-of-horror",
        "sun-ray",
        "shafts-of-plague"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Armory (or Market) unlocks the Heroic Age. Also researches several minor-god techs (listed in researches)."
      }
    },
    {
      "id": "sentry-tower",
      "name": {
        "pt-BR": "Torre de Sentinela",
        "en": "Sentry Tower"
      },
      "icon": "buildings/greeks-sentry-tower",
      "pantheon": "greeks",
      "cost": {
        "wood": 150,
        "gold": 100
      },
      "buildTime": 60,
      "limit": 30,
      "age": "classical",
      "researches": [
        "watch-tower",
        "guard-tower",
        "signal-fires",
        "carrier-pigeons",
        "crenellations",
        "boiling-oil"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Limit 30. Random maps place 4 at the start (lib/rm_util.xs). Upgrades: Watch Tower (Classical), Guard Tower (Heroic)."
      }
    },
    {
      "id": "fortress",
      "name": {
        "pt-BR": "Fortaleza",
        "en": "Fortress"
      },
      "icon": "buildings/greeks-fortress",
      "pantheon": "greeks",
      "cost": {
        "wood": 300,
        "gold": 300,
        "favor": 10
      },
      "buildTime": 150,
      "limit": 15,
      "age": "heroic",
      "trains": [
        "jason",
        "ajax",
        "theseus",
        "heracles",
        "achilles",
        "atalanta",
        "odysseus",
        "chiron",
        "hippolyta",
        "bellerophon",
        "perseus",
        "polyphemus",
        "petrobolos",
        "helepolis",
        "myrmidon",
        "gastraphetoros",
        "hetairos"
      ],
      "researches": [
        "draft-horses",
        "engineers",
        "advanced-fortifications",
        "beast-slayer",
        "argive-patronage",
        "olympian-parentage"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Limit 15. Required for the Mythic Age."
      }
    },
    {
      "id": "wall",
      "name": {
        "pt-BR": "Muralha de Madeira",
        "en": "Wooden Wall"
      },
      "icon": "buildings/greeks-wall",
      "pantheon": "greeks",
      "cost": {
        "gold": 15
      },
      "buildTime": 15,
      "age": "archaic",
      "researches": ["stone-wall", "fortified-wall"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cost/time are for one long segment (WallLong 15 gold, 15 build points). Connector 3 gold / 5, short 6 gold / 15, medium 9 gold / 15. Upgrades to Stone Wall (Classical) and Fortified Wall (Heroic)."
      }
    },
    {
      "id": "gate",
      "name": {
        "pt-BR": "Portão de Madeira",
        "en": "Wooden Gate"
      },
      "icon": "buildings/greeks-gate",
      "pantheon": "greeks",
      "cost": {
        "gold": 15
      },
      "buildTime": 15,
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "WallGate: 15 gold, 15 build points; placed by converting a wall segment."
      }
    },
    {
      "id": "wonder",
      "name": {
        "pt-BR": "Maravilha",
        "en": "Wonder"
      },
      "icon": "buildings/greeks-wonder",
      "pantheon": "greeks",
      "cost": {
        "food": 5000,
        "wood": 5000,
        "gold": 5000
      },
      "buildTime": 5400,
      "limit": 1,
      "age": "mythic",
      "trickle": {
        "favor": 60
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by MythicAgeGreek. proto.xml AutoGather Favor 1.0/s = 60 favor/min while it stands (trickle). Note: the Zeus favorRate modifier is unscoped, so the simulator also applies x1.2 to this trickle, while in game Zeus only boosts Temple prayer."
      }
    }
  ],
  "researches": [
    {
      "id": "husbandry",
      "name": {
        "pt-BR": "Pecuária",
        "en": "Husbandry"
      },
      "icon": "techs/greeks-husbandry",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "time": 30,
      "at": "granary",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["herd"]
          },
          "note": "+10% herdable gather rate. Also +15 food carry and +25% herd fattening (not modelled)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather Herdable x1.10 BasePercent; also +15 food carry and Herdable fattening x1.25 (not modelled)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "plow",
      "name": {
        "pt-BR": "Arado",
        "en": "Plow"
      },
      "icon": "techs/greeks-plow",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 50,
        "gold": 100
      },
      "time": 40,
      "at": "granary",
      "age": "classical",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather AbstractFarm x1.10 BasePercent."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "irrigation",
      "name": {
        "pt-BR": "Irrigação",
        "en": "Irrigation"
      },
      "icon": "techs/greeks-irrigation",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 150,
        "gold": 250
      },
      "time": 30,
      "at": "granary",
      "age": "heroic",
      "requires": ["plow"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather AbstractFarm x1.10 BasePercent."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "flood-control",
      "name": {
        "pt-BR": "Controle de Enchentes",
        "en": "Flood Control"
      },
      "icon": "techs/greeks-flood-control",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 250,
        "gold": 350
      },
      "time": 40,
      "at": "granary",
      "age": "mythic",
      "requires": ["irrigation"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather AbstractFarm x1.10 BasePercent."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "hand-axe",
      "name": {
        "pt-BR": "Machado de Mão",
        "en": "Hand Axe"
      },
      "icon": "techs/greeks-hand-axe",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 120,
        "gold": 50
      },
      "time": 30,
      "at": "storehouse",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["wood"]
          },
          "note": "+10% wood gather rate, +5 carry (carry not modelled)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather WoodResource x1.10 BasePercent; +5 wood carry (not modelled)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "bow-saw",
      "name": {
        "pt-BR": "Arco de Serra",
        "en": "Bow Saw"
      },
      "icon": "techs/greeks-bow-saw",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 250,
        "gold": 150
      },
      "time": 45,
      "at": "storehouse",
      "age": "heroic",
      "requires": ["hand-axe"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "sources": ["wood"]
          },
          "note": "+15% wood gather rate, +5 carry."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather WoodResource x1.15 BasePercent; +5 wood carry."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "carpenters",
      "name": {
        "pt-BR": "Carpinteiros",
        "en": "Carpenters"
      },
      "icon": "techs/greeks-carpenters",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 55,
      "at": "storehouse",
      "age": "mythic",
      "requires": ["bow-saw"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "sources": ["wood"]
          },
          "note": "+20% wood gather rate, +5 carry."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather WoodResource x1.20 BasePercent; +5 wood carry."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "pickaxe",
      "name": {
        "pt-BR": "Picareta",
        "en": "Pickaxe"
      },
      "icon": "techs/greeks-pickaxe",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 50,
        "wood": 120
      },
      "time": 30,
      "at": "storehouse",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["gold"]
          },
          "note": "+10% gold gather rate, +5 carry (carry not modelled)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather GoldResource x1.10 BasePercent; +5 gold carry."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "shaft-mine",
      "name": {
        "pt-BR": "Poços de Mina",
        "en": "Shaft Mine"
      },
      "icon": "techs/greeks-shaft-mine",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 150,
        "wood": 250
      },
      "time": 40,
      "at": "storehouse",
      "age": "heroic",
      "requires": ["pickaxe"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "sources": ["gold"]
          },
          "note": "+15% gold gather rate, +5 carry."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather GoldResource x1.15 BasePercent; +5 gold carry."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "quarry",
      "name": {
        "pt-BR": "Pedreira",
        "en": "Quarry"
      },
      "icon": "techs/greeks-quarry",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 50,
      "at": "storehouse",
      "age": "mythic",
      "requires": ["shaft-mine"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "sources": ["gold"]
          },
          "note": "+20% gold gather rate, +5 carry."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather GoldResource x1.20 BasePercent; +5 gold carry."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "purse-seine",
      "name": {
        "pt-BR": "Rede de Cerco",
        "en": "Purse Seine"
      },
      "icon": "techs/greeks-purse-seine",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "dock",
      "age": "classical",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "sources": ["fish"]
          },
          "note": "+50% fishing gather rate."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Fishing ships Gather FishResource x1.5 BasePercent."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "salt-amphora",
      "name": {
        "pt-BR": "Ânfora com Sal",
        "en": "Salt Amphora"
      },
      "icon": "techs/greeks-salt-amphora",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 200,
        "gold": 300
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["purse-seine"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "sources": ["fish"]
          },
          "note": "+50% fishing gather rate (+25 Fishing Ship carry)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Fishing ships Gather FishResource x1.5 BasePercent; +25 food carry."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "survival-equipment",
      "name": {
        "pt-BR": "Equipamento de sobrevivência",
        "en": "Survival Equipment"
      },
      "icon": "techs/greeks-survival-equipment",
      "pantheon": "greeks",
      "cost": {
        "wood": 100,
        "gold": 100
      },
      "time": 20,
      "at": "granary",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Villagers +25% HP, +10% melee attack, +50% ranged (anti-animal) attack. No gather-rate effect."
      }
    },
    {
      "id": "masons",
      "name": {
        "pt-BR": "Pedreiros",
        "en": "Masons"
      },
      "icon": "techs/greeks-masons",
      "pantheon": "greeks",
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 20,
      "at": "town-center",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Buildings +20% HP."
      }
    },
    {
      "id": "architects",
      "name": {
        "pt-BR": "Arquitetos",
        "en": "Architects"
      },
      "icon": "techs/greeks-architects",
      "pantheon": "greeks",
      "cost": {
        "food": 400,
        "wood": 500
      },
      "time": 30,
      "at": "town-center",
      "age": "heroic",
      "requires": ["masons"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Buildings +30% HP."
      }
    },
    {
      "id": "fortified-town-center",
      "name": {
        "pt-BR": "Centro Urbano Fortificado",
        "en": "Fortified Town Center"
      },
      "icon": "techs/greeks-fortified-town-center",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 400,
        "gold": 400
      },
      "time": 60,
      "at": "town-center",
      "age": "heroic",
      "effects": [
        {
          "target": "popCap",
          "op": "add",
          "value": 10,
          "scope": {
            "ids": ["town-center"]
          },
          "note": "+10 population per Town Center (15 -> 25)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "PopulationCapAddition +10 on TownCenter. Also +25% HP, +2 range, +50% ranged damage."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "tax-collectors",
      "name": {
        "pt-BR": "Coletores de Impostos",
        "en": "Tax Collectors"
      },
      "icon": "techs/greeks-tax-collectors",
      "pantheon": "greeks",
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 35,
      "at": "market",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Market buy factor -0.075, sell factor +0.075; tribute penalty -0.10 (market not modelled)."
      }
    },
    {
      "id": "ambassadors",
      "name": {
        "pt-BR": "Embaixadores",
        "en": "Ambassadors"
      },
      "icon": "techs/greeks-ambassadors",
      "pantheon": "greeks",
      "cost": {
        "gold": 250
      },
      "time": 30,
      "at": "market",
      "age": "mythic",
      "requires": ["tax-collectors"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Market buy factor -0.075, sell factor +0.075; tribute penalty set to 0."
      }
    },
    {
      "id": "coinage",
      "name": {
        "pt-BR": "Cunhagem",
        "en": "Coinage"
      },
      "icon": "techs/greeks-coinage",
      "pantheon": "greeks",
      "cost": {
        "gold": 200
      },
      "time": 40,
      "at": "market",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Caravans +20% speed."
      }
    },
    {
      "id": "levy-infantry",
      "name": {
        "pt-BR": "Convocar Infantaria",
        "en": "Levy Infantry"
      },
      "icon": "techs/greeks-levy-infantry",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 150
      },
      "time": 20,
      "at": "military-academy",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["hoplite", "hypaspist", "myrmidon", "militia"]
          },
          "note": "TrainPoints x0.80 Percent on InfantryLineUpgraded."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "conscript-infantry",
      "name": {
        "pt-BR": "Recrutar Infantaria",
        "en": "Conscript Infantry"
      },
      "icon": "techs/greeks-conscript-infantry",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 200
      },
      "time": 30,
      "at": "military-academy",
      "age": "mythic",
      "requires": ["levy-infantry"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["hoplite", "hypaspist", "myrmidon", "militia"]
          },
          "note": "TrainPoints x0.80 Percent on InfantryLineUpgraded."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "levy-ranged-soldiers",
      "name": {
        "pt-BR": "Convocar Soldados de Longo Alcance",
        "en": "Levy Ranged Soldiers"
      },
      "icon": "techs/greeks-levy-ranged-soldiers",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 150
      },
      "time": 20,
      "at": "archery-range",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["toxotes", "peltast", "gastraphetoros"]
          },
          "note": "TrainPoints x0.80 Percent on ArcherLineUpgraded."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "conscript-ranged-soldiers",
      "name": {
        "pt-BR": "Recrutar Soldados de Longo Alcance",
        "en": "Conscript Ranged Soldiers"
      },
      "icon": "techs/greeks-conscript-ranged-soldiers",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 200
      },
      "time": 30,
      "at": "archery-range",
      "age": "mythic",
      "requires": ["levy-ranged-soldiers"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["toxotes", "peltast", "gastraphetoros"]
          },
          "note": "TrainPoints x0.80 Percent on ArcherLineUpgraded."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "levy-cavalry",
      "name": {
        "pt-BR": "Convocar Cavalaria",
        "en": "Levy Cavalry"
      },
      "icon": "techs/greeks-levy-cavalry",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 150
      },
      "time": 20,
      "at": "stable",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["hippeus", "prodromos", "hetairos"]
          },
          "note": "TrainPoints x0.80 Percent on CavalryLineUpgraded."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "conscript-cavalry",
      "name": {
        "pt-BR": "Recrutar Cavalaria",
        "en": "Conscript Cavalry"
      },
      "icon": "techs/greeks-conscript-cavalry",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "food": 200
      },
      "time": 30,
      "at": "stable",
      "age": "mythic",
      "requires": ["levy-cavalry"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["hippeus", "prodromos", "hetairos"]
          },
          "note": "TrainPoints x0.80 Percent on CavalryLineUpgraded."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "conscript-sailors",
      "name": {
        "pt-BR": "Recrutar Marinheiros",
        "en": "Conscript Sailors"
      },
      "icon": "techs/greeks-conscript-sailors",
      "pantheon": "greeks",
      "tags": ["economy"],
      "cost": {
        "wood": 300
      },
      "time": 30,
      "at": "dock",
      "age": "mythic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": [
              "fishing-ship",
              "transport-ship",
              "trireme",
              "pentekonter",
              "juggernaut",
              "the-argo"
            ]
          },
          "note": "TrainPoints x0.80 Percent on Ship."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "TrainPoints x0.80 (Percent) on unit type Ship: Fishing Ship, Transport Ship, Trireme, Pentekonter, Juggernaut, The Argo (not Scylla, Carcinos, Hippocampus)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      }
    },
    {
      "id": "omniscience",
      "name": {
        "pt-BR": "Onisciência",
        "en": "Omniscience"
      },
      "icon": "techs/greeks-omniscience",
      "pantheon": "greeks",
      "cost": {},
      "time": 4,
      "at": "temple",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "DynamicCost: 100 gold per enemy unit (the file cost is 100 gold, multiplied in game), so cost is left empty. Reveals all enemy units."
      }
    },
    {
      "id": "medium-infantry",
      "name": {
        "pt-BR": "Infantaria Média",
        "en": "Medium Infantry"
      },
      "icon": "techs/greeks-medium-infantry",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 150,
        "gold": 150
      },
      "time": 20,
      "at": "military-academy",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heavy-infantry",
      "name": {
        "pt-BR": "Infantaria Pesada",
        "en": "Heavy Infantry"
      },
      "icon": "techs/greeks-heavy-infantry",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 300
      },
      "time": 30,
      "at": "military-academy",
      "age": "heroic",
      "requires": ["medium-infantry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "champion-infantry",
      "name": {
        "pt-BR": "Infantaria Campeã",
        "en": "Champion Infantry"
      },
      "icon": "techs/greeks-champion-infantry",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 500,
        "gold": 400
      },
      "time": 40,
      "at": "military-academy",
      "age": "mythic",
      "requires": ["heavy-infantry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "medium-ranged-soldiers",
      "name": {
        "pt-BR": "Soldados de Longo Alcance Médios",
        "en": "Medium Ranged Soldiers"
      },
      "icon": "techs/greeks-medium-ranged-soldiers",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "archery-range",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hades: cost x0.666 (Hades god modifier)."
      }
    },
    {
      "id": "heavy-ranged-soldiers",
      "name": {
        "pt-BR": "Soldados de Longo Alcance Pesados",
        "en": "Heavy Ranged Soldiers"
      },
      "icon": "techs/greeks-heavy-ranged-soldiers",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 300,
        "gold": 300
      },
      "time": 30,
      "at": "archery-range",
      "age": "heroic",
      "requires": ["medium-ranged-soldiers"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hades: cost x0.666 (Hades god modifier)."
      }
    },
    {
      "id": "champion-ranged-soldiers",
      "name": {
        "pt-BR": "Soldados de Longo Alcance Campeões",
        "en": "Champion Ranged Soldiers"
      },
      "icon": "techs/greeks-champion-ranged-soldiers",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 400
      },
      "time": 40,
      "at": "archery-range",
      "age": "mythic",
      "requires": ["heavy-ranged-soldiers"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hades: cost x0.666 (Hades god modifier)."
      }
    },
    {
      "id": "medium-cavalry",
      "name": {
        "pt-BR": "Cavalaria Média",
        "en": "Medium Cavalry"
      },
      "icon": "techs/greeks-medium-cavalry",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 100
      },
      "time": 20,
      "at": "stable",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heavy-cavalry",
      "name": {
        "pt-BR": "Cavalaria Pesada",
        "en": "Heavy Cavalry"
      },
      "icon": "techs/greeks-heavy-cavalry",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 400,
        "gold": 200
      },
      "time": 30,
      "at": "stable",
      "age": "heroic",
      "requires": ["medium-cavalry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "champion-cavalry",
      "name": {
        "pt-BR": "Cavalaria Campeã",
        "en": "Champion Cavalry"
      },
      "icon": "techs/greeks-champion-cavalry",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 700,
        "gold": 200
      },
      "time": 40,
      "at": "stable",
      "age": "mythic",
      "requires": ["heavy-cavalry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "copper-weapons",
      "name": {
        "pt-BR": "Armas de Cobre",
        "en": "Copper Weapons"
      },
      "icon": "techs/greeks-copper-weapons",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "gold": 100
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "copper-armor",
      "name": {
        "pt-BR": "Armadura de Cobre",
        "en": "Copper Armor"
      },
      "icon": "techs/greeks-copper-armor",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 75,
        "gold": 75
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "copper-shields",
      "name": {
        "pt-BR": "Escudos de Cobre",
        "en": "Copper Shields"
      },
      "icon": "techs/greeks-copper-shields",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 75,
        "gold": 75
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bronze-weapons",
      "name": {
        "pt-BR": "Armas de Bronze",
        "en": "Bronze Weapons"
      },
      "icon": "techs/greeks-bronze-weapons",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "requires": ["copper-weapons"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bronze-armor",
      "name": {
        "pt-BR": "Armadura de Bronze",
        "en": "Bronze Armor"
      },
      "icon": "techs/greeks-bronze-armor",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 150
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "requires": ["copper-armor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bronze-shields",
      "name": {
        "pt-BR": "Escudos de Bronze",
        "en": "Bronze Shields"
      },
      "icon": "techs/greeks-bronze-shields",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 200,
        "gold": 150
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "requires": ["copper-shields"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "iron-weapons",
      "name": {
        "pt-BR": "Armas de Ferro",
        "en": "Iron Weapons"
      },
      "icon": "techs/greeks-iron-weapons",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 450,
        "gold": 450
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "requires": ["bronze-weapons"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "iron-armor",
      "name": {
        "pt-BR": "Armadura de Ferro",
        "en": "Iron Armor"
      },
      "icon": "techs/greeks-iron-armor",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 400,
        "gold": 400
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "requires": ["bronze-armor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "iron-shields",
      "name": {
        "pt-BR": "Escudos de Ferro",
        "en": "Iron Shields"
      },
      "icon": "techs/greeks-iron-shields",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 400,
        "gold": 350
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "requires": ["bronze-shields"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "ballistics",
      "name": {
        "pt-BR": "Balística",
        "en": "Ballistics"
      },
      "icon": "techs/greeks-ballistics",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 50,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hades: cost x0.666 (Hades god modifier)."
      }
    },
    {
      "id": "burning-pitch",
      "name": {
        "pt-BR": "Breu Incendiário",
        "en": "Burning Pitch"
      },
      "icon": "techs/greeks-burning-pitch",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 300
      },
      "time": 40,
      "at": "armory",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hades: cost x0.666 (Hades god modifier)."
      }
    },
    {
      "id": "enclosed-deck",
      "name": {
        "pt-BR": "Convés Fechado",
        "en": "Enclosed Deck"
      },
      "icon": "techs/greeks-enclosed-deck",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "wood": 200
      },
      "time": 40,
      "at": "dock",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heroic-fleet",
      "name": {
        "pt-BR": "Frota Heroica",
        "en": "Heroic Fleet"
      },
      "icon": "techs/greeks-heroic-fleet",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "gold": 100,
        "favor": 10
      },
      "time": 20,
      "at": "dock",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heavy-warships",
      "name": {
        "pt-BR": "Navios de Guerra Pesados",
        "en": "Heavy Warships"
      },
      "icon": "techs/greeks-heavy-warships",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "dock",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "champion-warships",
      "name": {
        "pt-BR": "Navios de Guerra Campeões",
        "en": "Champion Warships"
      },
      "icon": "techs/greeks-champion-warships",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 250,
        "gold": 200
      },
      "time": 20,
      "at": "dock",
      "age": "mythic",
      "requires": ["heavy-warships"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "watch-tower",
      "name": {
        "pt-BR": "Torre de Vigia",
        "en": "Watch Tower"
      },
      "icon": "techs/greeks-watch-tower",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 250,
        "gold": 150
      },
      "time": 15,
      "at": "sentry-tower",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enables the Sentry Tower ranged attack."
      }
    },
    {
      "id": "guard-tower",
      "name": {
        "pt-BR": "Torre de Guarda",
        "en": "Guard Tower"
      },
      "icon": "techs/greeks-guard-tower",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 300,
        "gold": 300
      },
      "time": 40,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "signal-fires",
      "name": {
        "pt-BR": "Fogueiras Sinalizadoras",
        "en": "Signal Fires"
      },
      "icon": "techs/greeks-signal-fires",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 150
      },
      "time": 30,
      "at": "sentry-tower",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "carrier-pigeons",
      "name": {
        "pt-BR": "Pombos Correio",
        "en": "Carrier Pigeons"
      },
      "icon": "techs/greeks-carrier-pigeons",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 400
      },
      "time": 45,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["signal-fires"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "crenellations",
      "name": {
        "pt-BR": "Ameias",
        "en": "Crenellations"
      },
      "icon": "techs/greeks-crenellations",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 150,
        "wood": 150
      },
      "time": 20,
      "at": "sentry-tower",
      "age": "classical",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "boiling-oil",
      "name": {
        "pt-BR": "Óleo Fervente",
        "en": "Boiling Oil"
      },
      "icon": "techs/greeks-boiling-oil",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "wood": 300
      },
      "time": 40,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "stone-wall",
      "name": {
        "pt-BR": "Muralha de Pedra",
        "en": "Stone Wall"
      },
      "icon": "techs/greeks-stone-wall",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "wall",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "fortified-wall",
      "name": {
        "pt-BR": "Muralha Fortificada",
        "en": "Fortified Wall"
      },
      "icon": "techs/greeks-fortified-wall",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 500,
        "gold": 400
      },
      "time": 50,
      "at": "wall",
      "age": "heroic",
      "requires": ["stone-wall"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "draft-horses",
      "name": {
        "pt-BR": "Cavalos de Carga",
        "en": "Draft Horses"
      },
      "icon": "techs/greeks-draft-horses",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 40,
      "at": "fortress",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "engineers",
      "name": {
        "pt-BR": "Engenheiros",
        "en": "Engineers"
      },
      "icon": "techs/greeks-engineers",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 500
      },
      "time": 40,
      "at": "fortress",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "advanced-fortifications",
      "name": {
        "pt-BR": "Fortificações Avançadas",
        "en": "Advanced Fortifications"
      },
      "icon": "techs/greeks-advanced-fortifications",
      "pantheon": "greeks",
      "tags": ["military"],
      "cost": {
        "wood": 600,
        "gold": 600
      },
      "time": 30,
      "at": "fortress",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "olympian-parentage",
      "name": {
        "pt-BR": "Ascendência Olímpica",
        "en": "Olympian Parentage"
      },
      "icon": "techs/greeks-olympian-parentage",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "favor": 10
      },
      "time": 40,
      "at": "temple",
      "age": "archaic",
      "requires": ["zeus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Heroes +25% HP, +1 HP/s regeneration. Also available at the Fortress."
      }
    },
    {
      "id": "vaults-of-erebus",
      "name": {
        "pt-BR": "Cofres do Érebo",
        "en": "Vaults of Erebus"
      },
      "icon": "techs/greeks-vaults-of-erebus",
      "pantheon": "greeks",
      "tags": ["myth", "economy"],
      "cost": {
        "wood": 200,
        "favor": 15
      },
      "time": 40,
      "at": "storehouse",
      "age": "archaic",
      "requires": ["hades"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ResourceTrickleRate Gold +1.75/s (105/min) on the player."
      },
      "fieldMeta": {
        "trickle": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high"
        }
      },
      "trickle": {
        "gold": 105
      }
    },
    {
      "id": "lord-of-horses",
      "name": {
        "pt-BR": "Senhor dos Cavalos",
        "en": "Lord of Horses"
      },
      "icon": "techs/greeks-lord-of-horses",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 75,
        "favor": 5
      },
      "time": 25,
      "at": "stable",
      "age": "classical",
      "requires": ["poseidon"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cavalry and scouts +4 LOS, +0.5 HP/s regeneration."
      }
    },
    {
      "id": "labyrinth-of-minos",
      "name": {
        "pt-BR": "Labirinto de Minos",
        "en": "Labyrinth of Minos"
      },
      "icon": "techs/greeks-labyrinth-of-minos",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 250,
        "favor": 20
      },
      "time": 30,
      "at": "temple",
      "age": "classical",
      "requires": ["athena"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Minotaur -> Bull Minotaur: +35% HP, +15% speed."
      }
    },
    {
      "id": "aegis-shield",
      "name": {
        "pt-BR": "Égide",
        "en": "Aegis Shield"
      },
      "icon": "techs/greeks-aegis-shield",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 200,
        "favor": 20
      },
      "time": 40,
      "at": "military-academy",
      "age": "classical",
      "requires": ["athena"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Infantry -15% pierce vulnerability. Also at the Armory."
      }
    },
    {
      "id": "sarissa",
      "name": {
        "pt-BR": "Sarissa",
        "en": "Sarissa"
      },
      "icon": "techs/greeks-sarissa",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 125,
        "favor": 20
      },
      "time": 40,
      "at": "military-academy",
      "age": "classical",
      "requires": ["athena"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hoplites +10% hack attack, +0.5 range. Also at the Armory."
      }
    },
    {
      "id": "sylvan-lore",
      "name": {
        "pt-BR": "Sabedoria Silvana",
        "en": "Sylvan Lore"
      },
      "icon": "techs/greeks-sylvan-lore",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 250,
        "favor": 18
      },
      "time": 40,
      "at": "temple",
      "age": "classical",
      "requires": ["hermes"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Centaur -> Centaur Polemarch: +35% HP, +3 range, +1 LOS."
      }
    },
    {
      "id": "winged-messenger",
      "name": {
        "pt-BR": "Mensageiro Alado",
        "en": "Winged Messenger"
      },
      "icon": "techs/greeks-winged-messenger",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 50,
        "favor": 3
      },
      "time": 30,
      "at": "temple",
      "age": "classical",
      "requires": ["hermes"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Pegasi +20% speed, +6 LOS; adds a respawning Pegasus at a Temple (WingedMessengerRespawn; not modelled)."
      }
    },
    {
      "id": "spirited-charge",
      "name": {
        "pt-BR": "Avanço Intrépido",
        "en": "Spirited Charge"
      },
      "icon": "techs/greeks-spirited-charge",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 125,
        "favor": 20
      },
      "time": 40,
      "at": "stable",
      "age": "classical",
      "requires": ["hermes"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cavalry +10% speed and melee attack; Centaurs +10% speed, +5% attack."
      }
    },
    {
      "id": "phobos-spear-of-panic",
      "name": {
        "pt-BR": "Lança do Pânico de Fobos",
        "en": "Phobos' Spear of Panic"
      },
      "icon": "techs/greeks-phobos-spear-of-panic",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "favor": 15
      },
      "time": 40,
      "at": "military-academy",
      "age": "classical",
      "requires": ["ares"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hoplites, Prodromoi and Militia +1 divine attack. Also at Stable/Armory."
      }
    },
    {
      "id": "deimos-sword-of-dread",
      "name": {
        "pt-BR": "Espada do Medo de Deimos",
        "en": "Deimos' Sword of Dread"
      },
      "icon": "techs/greeks-deimos-sword-of-dread",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 10
      },
      "time": 20,
      "at": "military-academy",
      "age": "classical",
      "requires": ["ares"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hypaspists +15% melee damage and enabled (from the Classical Age). Also at the Armory."
      }
    },
    {
      "id": "enyos-bow-of-horror",
      "name": {
        "pt-BR": "Arco do Horror de Ênio",
        "en": "Enyo's Bow of Horror"
      },
      "icon": "techs/greeks-enyos-bow-of-horror",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 125,
        "favor": 12
      },
      "time": 20,
      "at": "archery-range",
      "age": "classical",
      "requires": ["ares"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Toxotes +10% ranged damage; arrow speed +20. Also at the Armory. Hades: wood and favor cost x0.666."
      }
    },
    {
      "id": "will-of-kronos",
      "name": {
        "pt-BR": "Vontade de Cronos",
        "en": "Will of Kronos"
      },
      "icon": "techs/greeks-will-of-kronos",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 10
      },
      "time": 40,
      "at": "temple",
      "age": "classical",
      "requires": ["ares"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cyclops -> Elder Cyclops (area damage)."
      }
    },
    {
      "id": "anastrophe",
      "name": {
        "pt-BR": "Anástrofe",
        "en": "Anastrophe"
      },
      "icon": "techs/greeks-anastrophe",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 100,
        "gold": 100,
        "favor": 15
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["apollo"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Pentekonters gain Critical Strike."
      }
    },
    {
      "id": "oracle",
      "name": {
        "pt-BR": "Oráculo",
        "en": "Oracle"
      },
      "icon": "techs/greeks-oracle",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 75,
        "favor": 10
      },
      "time": 30,
      "at": "temple",
      "age": "heroic",
      "requires": ["apollo"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Units and buildings +5 LOS; see enemy production queues."
      }
    },
    {
      "id": "temple-of-healing",
      "name": {
        "pt-BR": "Templo de Cura",
        "en": "Temple of Healing"
      },
      "icon": "techs/greeks-temple-of-healing",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 75,
        "favor": 12
      },
      "time": 30,
      "at": "temple",
      "age": "heroic",
      "requires": ["apollo"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temples heal up to 3 nearby units."
      }
    },
    {
      "id": "sun-ray",
      "name": {
        "pt-BR": "Raio de Sol",
        "en": "Sun Ray"
      },
      "icon": "techs/greeks-sun-ray",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "favor": 20
      },
      "time": 30,
      "at": "archery-range",
      "age": "heroic",
      "requires": ["apollo"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Ranged units +15% ranged damage; projectiles reveal LOS. Also at the Armory. Hades: food and favor cost x0.666."
      }
    },
    {
      "id": "chthonic-rites",
      "name": {
        "pt-BR": "Ritos Ctônicos",
        "en": "Chthonic Rites"
      },
      "icon": "techs/greeks-chthonic-rites",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 100,
        "favor": 25
      },
      "time": 25,
      "at": "temple",
      "age": "heroic",
      "requires": ["dionysus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hydrai and Scyllai regenerate 4 HP/s. Also at the Dock."
      }
    },
    {
      "id": "dionysia",
      "name": {
        "pt-BR": "Dionísia",
        "en": "Dionysia"
      },
      "icon": "techs/greeks-dionysia",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 150,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["dionysus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "All units +5% HP."
      }
    },
    {
      "id": "thracian-horses",
      "name": {
        "pt-BR": "Cavalos Trácios",
        "en": "Thracian Horses"
      },
      "icon": "techs/greeks-thracian-horses",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 150,
        "favor": 30
      },
      "time": 40,
      "at": "stable",
      "age": "heroic",
      "requires": ["dionysus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cavalry heal 30% of damage dealt to units."
      }
    },
    {
      "id": "argonauts",
      "name": {
        "pt-BR": "Argonautas",
        "en": "Argonauts"
      },
      "icon": "techs/greeks-argonauts",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 100,
        "gold": 100,
        "favor": 15
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["aphrodite"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Creates The Argo at a Dock and enables it (no spawn field for researches)."
      }
    },
    {
      "id": "divine-blood",
      "name": {
        "pt-BR": "Sangue Divino",
        "en": "Divine Blood"
      },
      "icon": "techs/greeks-divine-blood",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "favor": 25
      },
      "time": 30,
      "at": "town-center",
      "age": "heroic",
      "requires": ["aphrodite"],
      "effects": [
        {
          "target": "buildRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "ids": ["villager"]
          },
          "note": "+15% build rate. Also +20% villager speed and +10 carry capacity (not modelled)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Villager Build x1.15 BasePercent; +10 food/wood/gold carry (not modelled). Also at the Village Center."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. DivineBlood: Build WorkRate x1.15 BasePercent on EconomicUpgraded (all buildings)."
        }
      }
    },
    {
      "id": "golden-apples",
      "name": {
        "pt-BR": "Maçãs Douradas",
        "en": "Golden Apples"
      },
      "icon": "techs/greeks-golden-apples",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "gold": 75
      },
      "time": 30,
      "at": "town-center",
      "age": "heroic",
      "requires": ["aphrodite"],
      "effects": [
        {
          "target": "favorRate",
          "op": "pct",
          "value": 0.2,
          "note": "Villagers gather favor 20% faster (M = 1.2 in the prayer formula)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Villager Gather AbstractTemple x1.20 BasePercent (favor M = 1.2; with Zeus 1.4). Also at the Village Center and Temple."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. GoldenApples: Gather WorkRate on AbstractTemple x1.20 BasePercent; with Zeus (also x1.20 BasePercent) the total is +40%, not x1.44."
        }
      }
    },
    {
      "id": "roar-of-orthus",
      "name": {
        "pt-BR": "Rugido de Ortros",
        "en": "Roar of Orthus"
      },
      "icon": "techs/greeks-roar-of-orthus",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 300,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["aphrodite"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Nemean Lion -> Nemean Rex: Roar area doubled."
      }
    },
    {
      "id": "hand-of-talos",
      "name": {
        "pt-BR": "Mão de Talos",
        "en": "Hand of Talos"
      },
      "icon": "techs/greeks-hand-of-talos",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 200,
        "favor": 15
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hephaestus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Colossus -> Silver Colossus: +25% HP."
      }
    },
    {
      "id": "shoulder-of-talos",
      "name": {
        "pt-BR": "Ombro de Talos",
        "en": "Shoulder of Talos"
      },
      "icon": "techs/greeks-shoulder-of-talos",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 20
      },
      "time": 50,
      "at": "temple",
      "age": "mythic",
      "requires": ["hephaestus", "hand-of-talos"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Silver -> Gold Colossus: +30% HP, -20% hack vulnerability."
      }
    },
    {
      "id": "olympian-weapons",
      "name": {
        "pt-BR": "Armas Olímpicas",
        "en": "Olympian Weapons"
      },
      "icon": "techs/greeks-olympian-weapons",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 20
      },
      "time": 40,
      "at": "armory",
      "age": "mythic",
      "requires": ["hephaestus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Myrmidons, Hetairoi, Gastraphetoroi +20% attack, +1x vs myth units."
      }
    },
    {
      "id": "forge-of-olympus",
      "name": {
        "pt-BR": "Forja do Olimpo",
        "en": "Forge of Olympus"
      },
      "icon": "techs/greeks-forge-of-olympus",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 30
      },
      "time": 5,
      "at": "armory",
      "age": "mythic",
      "requires": ["hephaestus"],
      "effects": [
        {
          "target": "cost",
          "op": "mul",
          "value": 0.25,
          "scope": {
            "ids": [
              "copper-weapons",
              "copper-armor",
              "copper-shields",
              "bronze-weapons",
              "bronze-armor",
              "bronze-shields",
              "iron-weapons",
              "iron-armor",
              "iron-shields",
              "ballistics",
              "burning-pitch",
              "olympian-weapons"
            ],
            "resources": ["food", "wood", "gold"]
          },
          "note": "CostBuildingTechs x0.25 Percent on the Armory (food/wood/gold)."
        },
        {
          "target": "researchTime",
          "op": "mul",
          "value": 0.6667,
          "scope": {
            "ids": [
              "copper-weapons",
              "copper-armor",
              "copper-shields",
              "bronze-weapons",
              "bronze-armor",
              "bronze-shields",
              "iron-weapons",
              "iron-armor",
              "iron-shields",
              "ballistics",
              "burning-pitch",
              "olympian-weapons"
            ]
          },
          "note": "Armory ResearchRate x1.5 BasePercent -> research time / 1.5."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "CostBuildingTechs x0.25 (Percent) on the Armory for food, wood and gold (favor unchanged); Armory ResearchRate x1.5 BasePercent (time / 1.5)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "ForgeOfOlympus: CostBuildingTechs x0.25 Percent (food, wood, gold) and ResearchRate x1.5 BasePercent on the Armory."
        }
      }
    },
    {
      "id": "face-of-the-gorgon",
      "name": {
        "pt-BR": "Rosto da Górgona",
        "en": "Face of the Gorgon"
      },
      "icon": "techs/greeks-face-of-the-gorgon",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "wood": 300,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hera"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Medusa -> Medusa Matriarch: +5 range, -25% ability recharge."
      }
    },
    {
      "id": "monstrous-rage",
      "name": {
        "pt-BR": "Fúria Monstruosa",
        "en": "Monstrous Rage"
      },
      "icon": "techs/greeks-monstrous-rage",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 250,
        "favor": 25
      },
      "time": 30,
      "at": "temple",
      "age": "mythic",
      "requires": ["hera"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Myth units -25% reload time, +15% speed."
      }
    },
    {
      "id": "argive-patronage",
      "name": {
        "pt-BR": "Patrocínio Argivo",
        "en": "Argive Patronage"
      },
      "icon": "techs/greeks-argive-patronage",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 200,
        "gold": 300,
        "favor": 30
      },
      "time": 40,
      "at": "fortress",
      "age": "mythic",
      "requires": ["hera"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Tech ArgivePatronageZeus (needs MythicAgeZeus, so Zeus only): Fortresses get a Maintain action that trains one free Myrmidon per 60 train points."
      }
    },
    {
      "id": "shafts-of-plague",
      "name": {
        "pt-BR": "Lanças da Praga",
        "en": "Shafts of Plague"
      },
      "icon": "techs/greeks-shafts-of-plague",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 30
      },
      "time": 40,
      "at": "archery-range",
      "age": "mythic",
      "requires": ["artemis"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Ranged soldiers +10% ranged damage and poison. Also at the Armory. Hades: gold and favor cost x0.666."
      }
    },
    {
      "id": "flames-of-typhon",
      "name": {
        "pt-BR": "Chamas de Tifão",
        "en": "Flames of Typhon"
      },
      "icon": "techs/greeks-flames-of-typhon",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 300,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["artemis"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Chimera -> Chimera Tyrant: +40% attack."
      }
    },
    {
      "id": "beast-slayer",
      "name": {
        "pt-BR": "Matador de Feras",
        "en": "Beast Slayer"
      },
      "icon": "techs/greeks-beast-slayer",
      "pantheon": "greeks",
      "tags": ["myth"],
      "cost": {
        "food": 125,
        "gold": 125,
        "favor": 20
      },
      "time": 30,
      "at": "fortress",
      "age": "mythic",
      "requires": ["artemis"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Heroes +2x vs myth units, +10% speed."
      }
    }
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml, proto.xml, string tables)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Base game only (Demeter, Pan, Hestia, Persephone and their units excluded). Start (major_gods.xml): 4 Villagers, 1 Kataskopos, 200 food / 250 wood / 50 gold (Zeus +10 favor); 4 Sentry Towers from the random-map scripts. Names from the English and PortugueseBrazil string tables."
  }
}
